var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"codox-editor"},[_c('main',[_c('quill-editor',{ref:"editor",model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_c('footer',[_c('v-btn',{attrs:{"color":"primary","depressed":"","large":""},on:{"click":_vm.saveActivity}},[_vm._v(_vm._s(_vm.$t('save'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }